var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx_content"},[_c('div',{staticClass:"mx_title"},[_vm._m(0),_c('div',{staticClass:"title_right"},[(_vm.canEdit)?_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.xuanze}},[_vm._v("选择")]):_vm._e(),(_vm.canEdit)?_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.addMx}},[_vm._v("新增")]):_vm._e()],1)]),(_vm.updated)?_c('el-table',{staticClass:"border",staticStyle:{"width":"100%"},attrs:{"data":_vm.listData},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"type":"index","label":"序号","width":"50","align":"center"}}),_c('el-table-column',{attrs:{"prop":"itemName","align":"center"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('span',{staticClass:"required"},[_vm._v("*")]),_c('span',[_vm._v("项目名称")])]},proxy:true},{key:"default",fn:function(scope){return [(_vm.canEdit)?_c('div',{staticClass:"itemName",on:{"click":function($event){return _vm.dialogClick(scope.$index)}}},[_c('form-item',{ref:"itemName",attrs:{"field":{
                            defaultValue: null,
                            elementCanEdit: '{${curTN.tnCanEdit}}',
                            elementCssHeight: 100,
                            elementCssWidth: null,
                            elementFormatter: null,
                            elementReadonly: 0,
                            elementType: 'input',
                            emptyMessage: '请输入项目名称',
                            errorMessage: null,
                            formTdAlign: 'text-left',
                            formTdColspan: 100,
                            isRequired: 1,
                            onClickEvent: null,
                            passenger: {},
                            propComment: '项目名称',
                            propName: 'itemName',
                            propType: 'String',
                            textFormatter: 'input',
                            valueMaxLength: null,
                            valueMinLength: null,
                            model: 'scope.row.itemName',
                            option: [],
                            autocomplete: 'off',
                            dialog: 1,
                            showWordLimit: false,
                            dialogType: 'listpage',
                            dialogOrgLevel: '',
                            dialogListviewurl: _vm.dataUrl
                        },"vo":scope.row,"can-edit":_vm.canEdit}}),_c('form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"itemNameNew",attrs:{"field":{
                            defaultValue: null,
                            elementCanEdit: '{${curTN.tnCanEdit}}',
                            elementCssHeight: 100,
                            elementCssWidth: null,
                            elementFormatter: null,
                            elementReadonly: 0,
                            elementType: 'input',
                            emptyMessage: '请输入项目名称',
                            errorMessage: null,
                            formTdAlign: 'text-left',
                            formTdColspan: 100,
                            isRequired: 0,
                            onClickEvent: null,
                            passenger: {},
                            propComment: '项目名称',
                            propName: 'xuanzeXm',
                            propType: 'String',
                            textFormatter: 'input',
                            valueMaxLength: null,
                            valueMinLength: null,
                            model: 'scope.row.xuanzeXm',
                            option: [],
                            autocomplete: 'off',
                            dialog: 1,
                            showWordLimit: false,
                            dialogType: 'listpage',
                            dialogOrgLevel: '',
                            dialogListviewurl: 'zjgl.zjxmArch.list'
                        },"vo":scope.row,"can-edit":_vm.canEdit}})],1):_c('div',[_vm._v(_vm._s(scope.row.itemName))])]}}],null,false,629119998)}),_c('el-table-column',{attrs:{"prop":"businessType","align":"center","width":_vm.canEdit == 1 ? '180' : ''},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('span',{staticClass:"required"},[_vm._v("*")]),_c('span',[_vm._v("业务类型")])]},proxy:true},{key:"default",fn:function(scope){return [(_vm.canEdit)?_c('div',[_c('form-item',{ref:"businessType",attrs:{"field":{
                            defaultValue: null,
                            elementCanEdit: '0',
                            elementCssHeight: null,
                            elementCssWidth: null,
                            elementFormatter: '1：司法鉴定\n2：评估报告\n3：工程量验收报告\n4：概算\n5：预算\n6：预算\n7：结算\n8：结算审核报告\n9：工程量清单\n10：预算控制价审核\n11：全过程\n12：招标控制价',
                            elementReadonly: 1,
                            elementType: 'select',
                            emptyMessage: '请选择业务类型',
                            errorMessage: null,
                            formTdAlign: 'text-left',
                            formTdColspan: 0,
                            isRequired: 1,
                            onClickEvent: null,
                            passenger: {},
                            propComment: '业务类型',
                            propName: 'businessType',
                            propType: 'Short',
                            textFormatter: null,
                            valueMaxLength: null,
                            valueMinLength: null,
                            model: 'scope.row.businessType',
                            option: [
                                { value: '1', name: '司法鉴定' },
                                { value: '2', name: '评估报告' },
                                { value: '3', name: '工程量验收报告' },
                                { value: '4', name: '概算' },
                                { value: '5', name: '预算' },
                                { value: '6', name: '预算' },
                                { value: '7', name: '结算' },
                                { value: '8', name: '结算审核报告' },
                                { value: '9', name: '工程量清单' },
                                { value: '10', name: '预算控制价审核' },
                                { value: '11', name: '全过程' },
                                { value: '12', name: '招标控制价' }
                            ],
                            optionGenerateType: 0,
                            clearable: false,
                            filterable: false,
                            allowCreate: false,
                            remoteMethod: '',
                            readonlyShowChecked: 0
                        },"vo":scope.row,"can-edit":_vm.canEdit}})],1):_c('div',[_vm._v(_vm._s(_vm.setType(scope.row.businessType)))])]}}],null,false,4084141907)}),_c('el-table-column',{attrs:{"prop":"projectLeader","align":"center","width":_vm.canEdit == 1 ? '180' : ''},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('span',{staticClass:"required"},[_vm._v("*")]),_c('span',[_vm._v("项目负责人")])]},proxy:true},{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(scope.row.projectLeader))])]}}],null,false,663733828)}),_c('el-table-column',{attrs:{"prop":"companyNumber","align":"center","width":"200"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('span',{staticClass:"required"},[_vm._v("*")]),_c('span',[_vm._v("公司统一编号")])]},proxy:true},{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(scope.row.companyNumber))])]}}],null,false,551998965)}),(_vm.canEdit)?_c('el-table-column',{attrs:{"label":"操作","align":"center","width":"70px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-link',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.delClick(scope.row)}}},[_vm._v("删除")])]}}],null,false,1860585361)}):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title_left"},[_c('span',{staticStyle:{"color":"#333333","font-weight":"bold"}},[_vm._v("结算项目")])])
}]

export { render, staticRenderFns }